<template>
    <div :class="{'box-shadowed': isBoxShadow}" class="content-link-style-guide">
        <span class="icon" :class="[iconName, isJACareerEntrepreApp ? 'link-green-dark' : 'link-green-light']"></span>
        <b-link tabindex="0" @click="onOpenUrl" class="document-link" :href="url" :target="target" >{{text}}</b-link>
    </div>
</template>

<script>
    export default {
        name: "Spinner",
        props: {
            url: {
                type: String,
                default: 'javascript:void(0)'
            },
            iconName: {
                type: String,
                required: true
            },
            text:{
                type: String,
                required: true
            },
            target: {
                type: String,
                default: '_self',
            },
            isBoxShadow:{
                type: Boolean,
                default: true,
            }
        },
        methods: {
            onOpenUrl: function (e) {
                this.$emit('open-url', e);
            }
        },
    };
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/mixins.styl"
    @import "~@/core/Styles/variables.styl";

    .content-link-style-guide
        padding 15px
        display flex
        align-items center

</style>
